import axios from 'axios';
import { Store } from 'redux';
import { IStore } from '../redux/IStore';
import { actions as authActions } from '../services/auth/reducer';

export default class AuthInterceptor {
  public ignoredUrls = [];
  public req = null;
  public res = null;
  public interceptor = null;
  private store: Store<IStore>;

  constructor(store: Store<IStore>) {
    this.store = store;
  }

  public registerInterceptor() {
    this.interceptor = axios.interceptors.response.use(this.requestSuccess, this.requestFailure.bind(this));
  }

  public requestSuccess = (response) => {
    return response;
  }

  public requestFailure = (error) => {
    if (this.ignoredUrls.length === 0) {
      this.ignoredUrls.push('/auth/login');
      this.ignoredUrls.push('/auth/refresh');
      this.ignoredUrls.push('/auth/logout');
      this.ignoredUrls.push(axios.defaults.baseURL + '/oauth/access_token');
    }

    // Only deal with auth failures
    if (error.response.status !== 401 || this.ignoredUrls.indexOf(error.response.config.url) !== -1) {
      return Promise.reject(error);
    }

    this.store.dispatch(authActions.logout());

    return Promise.reject(error);
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/helpers/AuthInterceptor.ts